// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TiersStatuses-module-tiersStatuses-2_j7N{display:flex;padding:10px;flex-direction:column;gap:20px;background-color:#fbfbfb;border-radius:8px;align-items:flex-start}@media(min-width: 768px){.TiersStatuses-module-tiersStatuses-2_j7N{flex-direction:row}}.TiersStatuses-module-tierItem-3cxoI{display:flex;align-items:center}.TiersStatuses-module-tierName-2aK9p,.TiersStatuses-module-pointsRange-13X-J,.TiersStatuses-module-icon-2E9Yi{color:#afafaf}.TiersStatuses-module-tierName-2aK9p{overflow:hidden;text-align:center;text-overflow:ellipsis;font-size:14px;line-height:23px}.TiersStatuses-module-pointsRange-13X-J{margin-inline-start:5px;font-size:12px}.TiersStatuses-module-icon-2E9Yi{margin-inline-start:10px}.TiersStatuses-module-active-3XZeN *{color:#5c5c5c}", ""]);
// Exports
exports.locals = {
	"tiersStatuses": "TiersStatuses-module-tiersStatuses-2_j7N",
	"tierItem": "TiersStatuses-module-tierItem-3cxoI",
	"tierName": "TiersStatuses-module-tierName-2aK9p",
	"pointsRange": "TiersStatuses-module-pointsRange-13X-J",
	"icon": "TiersStatuses-module-icon-2E9Yi",
	"active": "TiersStatuses-module-active-3XZeN"
};
module.exports = exports;
